import { ICompositeProductApi } from '@canvas-logic/clp-sdk';
import { IUICfgAttributeInteger } from '@canvas-logic/clp-api-types';
import { AttributeStateBase } from '@/elements/base/AttributeStateBase';

let id = 0;

export class IntegerAttributeState extends AttributeStateBase<IUICfgAttributeInteger, number> {
  readonly elementKind = 'attribute';
  readonly elementType = 'integer';
  public id = 'integer-view-state-' + ++id;

  constructor(api: ICompositeProductApi, element: IUICfgAttributeInteger) {
    super(api, element);
    this.initValueState();
  }
}
